// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"928fc663","135":"12e0c79c","453":"419a5d54","568":"26510ffb","903":"279441be"}[chunkId] + ".chunk.js";
};